import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import Moment from "react-moment";
import { connect } from "react-redux";
import {
  addArticleLike,
  removeArticleLike,
  addComment,
} from "../../../actions/article";

import PublishedArticle from "../IME/PublishedArticle";

const ArticleItem = ({
  addArticleLike,
  removeArticleLike,
  article: {
    _id,
    avatar,
    title,
    articleimage,
    keywords,
    blocks,
    firstname,
    lastname,
    jobtitle,
    location,
    likes,
    comments,
    date,
  },
  addComment,
  isAuthenticated,
}) => {
  const [showArticle, setshowArticle] = useState(false);
  const [comment, setComment] = useState("");
  return (
    <Fragment>
      <div className="recent-article">
        <div className="recent-article-image">
          <img
            src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/article_images/${articleimage}`}
            alt=""
            className="trending-image"
            onClick={(e) => setshowArticle(e)}
          />
        </div>
        <div className="recent-article-desc">
          <div className="article-relative">
            <div className="article-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                className="article-avi"
              />
              <i className="fas fa-ellipsis-v green mx-10 p-y cursor"></i>
              <div className="article-modal">
                <ul className="modal-items">
                  <li className="modal-item">
                    <i className="fas fa-flag mx-5 white"></i>
                    Report
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="article-list-items max-width-sm">
            <ul className="article-items">
              <li className="article-item">
                <i className="fas fa-book-open mx-5 green"></i>
                {title}
              </li>
            </ul>
          </div>
          <div className="date-container">
            <i className="far fa-clock mx-5 green"></i>
            <Moment format="MM/DD/YYYY">{date}</Moment>
          </div>
          {isAuthenticated && (
            <div className="article-icons">
              <ul className="trending-icons">
                <li className="icon mx-5">
                  <i
                    className="far fa-thumbs-up mx-5 green"
                    onClick={() => addArticleLike(_id)}
                  ></i>
                  {likes && likes.length > 0 && (
                    <span>{likes && likes.length}</span>
                  )}
                  <i
                    className="far fa-thumbs-down green mx-5"
                    onClick={() => removeArticleLike(_id)}
                  ></i>
                </li>
                <li className="icon mx-5">
                  <i className="far fa-comment green mx-5"></i>
                  {comments && comments.length > 0 && (
                    <span>{comments && comments.length}</span>
                  )}
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
      {showArticle && (
        <PublishedArticle
          _id={_id}
          avatar={avatar}
          firstname={firstname}
          lastname={lastname}
          jobtitle={jobtitle}
          location={location}
          // addLike={addLike}
          likes={likes}
          comments={comments}
          comment={comment}
          setshowArticle={setshowArticle}
          // addPostComment={addPostComment}
          setComment={setComment}
          keywords={keywords}
          blocks={blocks}
          articleimage={articleimage}
          title={title}
          date={date}
          isAuthenticated={isAuthenticated}
        />
      )}
    </Fragment>
  );
};

ArticleItem.propTypes = {
  article: PropTypes.object.isRequired,
  addArticleLike: PropTypes.func.isRequired,
  removeArticleLike: PropTypes.func.isRequired,
  addComment: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  comment: state.comment,
  reply: state.reply,
});

export default connect(mapStateToProps, {
  addArticleLike,
  removeArticleLike,
  addComment,
})(ArticleItem);
